import { usePDP } from '../../../contexts/pdp/usePDP';
import { isHydrated } from '../../../utils/utils';
import type { RequestParams } from '../../../components/apple-pay-button/ApplePay.types';

type UseCheckApplePayEligibilityProps = {
    customAmount?: number;
    giftMessage?: string;
    senderName?: string;
    recipientName?: string;
    recipientEmail?: string;
};

export const useCheckApplePayEligibility = ({
    customAmount,
    giftMessage,
    senderName,
    recipientName,
    recipientEmail,
}: UseCheckApplePayEligibilityProps): {
    isApplePayVisible: boolean;
    params?: RequestParams;
} => {
    const { product, selectedQuantity } = usePDP();

    if (!product) {
        return {
            isApplePayVisible: false,
        };
    }

    const { isApplePayElegible } = product;

    const isApplePayVisible = Boolean(isApplePayElegible) && isHydrated();

    const params = {
        pid: product.id,
        isFromPWA: 'true',
        isProductVariant: 'true',
        Quantity: selectedQuantity ?? 1,
        source: 'gdp',
        dwfrm_giftcard_customAmount: customAmount,
        dwfrm_giftcard_giftMessage: giftMessage ?? '',
        dwfrm_giftcard_senderName: senderName ?? '',
        dwfrm_giftcard_recipientName: recipientName ?? '',
        dwfrm_giftcard_recipientEmail: recipientEmail ?? '',
    };

    return {
        isApplePayVisible,
        params,
    };
};
